import { LocalizedData } from './localized-data';
import { PageItemWithCountries } from './page-item';
import { PartialProgram } from './program';
import { TrayWithBackgroundImages, TrayWithScheduling } from './tray-common';

export enum SeasonTrayContentSort {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export interface SeasonTray extends PageItemWithCountries, TrayWithScheduling, TrayWithBackgroundImages {
  type: 'SeasonTray';
  title: LocalizedData<string>;
  description: LocalizedData<string>;
  seriesId: string;
  sort: SeasonTrayContentSort;
  program?: PartialProgram;
}
